/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { entitiesUpdateInstruction } from "../../funcs/entitiesUpdateInstruction.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateInstructionRequest$inboundSchema,
};

export const tool$entitiesUpdateInstruction: ToolDefinition<typeof args> = {
  name: "entities-update-instruction",
  description: `Update Instruction`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await entitiesUpdateInstruction(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
